<div
  class="u-borderBottom-grey100"
  mat-dialog-title
  i18n="@@global.editProfile"
>
  Edit Profile
</div>
<mat-dialog-content class="u-borderBottom-grey100 u-borderBottom-grey100">
  <ng-container *ngIf="!!form">
    <form [formGroup]="form" class="u-paddingTop-16 text-body-2">
      <p
        i18n="@@profileView.editDialog.summary.subtitle"
        class="text-subtitle-1 u-marginBottom-16"
      >
        Summary
      </p>
      <div fxLayout.gt-sm="row" fxLayoutGap.gt-sm="1%">
        <mat-form-field fxFlex.gt-sm="49%" class="mat-form-field-width-100">
          <mat-label i18n="@@profileView.editDialog.firstName.label"
            >First name
          </mat-label>
          <input
            matInput
            formControlName="first_name"
            autocomplete="off"
            required
          />
        </mat-form-field>
        <mat-form-field fxFlex.gt-sm="49%" class="mat-form-field-width-100">
          <mat-label i18n="@@profileView.editDialog.lastName.label"
            >Last name
          </mat-label>
          <input
            matInput
            formControlName="last_name"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>
      <mat-form-field
        *ngIf="user.isAdmin && !isUser"
        class="mat-form-field-width-100"
      >
        <mat-label i18n="@@global.email">Email</mat-label>
        <input matInput type="email" formControlName="email" required />
      </mat-form-field>
      <ng-container *ngIf="tenantState | async as tenant">
        <mat-form-field
          *ngIf="tenant.enabled_features.profile"
          class="mat-form-field-width-100 u-marginBottom-16"
        >
          <mat-label i18n="@@profileView.editDialog.pronouns.label"
            >Pronouns
          </mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            autocomplete="off"
            formControlName="pronouns"
            [maxlength]="pronounsCharacterLimit"
          >
          </textarea>
          <mat-hint i18n="@@profileView.editDialog.pronouns.hint" align="start">
            Enter some or all of your pronouns, e.g., she/her, he/him, they/them
          </mat-hint>
          <mat-hint align="end">
            {{ form.value.pronouns?.length || 0 }}/{{ pronounsCharacterLimit }}
          </mat-hint>
          <mat-error
            *ngIf="form.get('pronouns').hasError('maxlength')"
            i18n="@@profileView.editDialog.pronouns.error"
          >
            Sorry, the text you entered is too long! ({{
              form.get('pronouns').getError('maxlength').actualLength
            }}/{{ form.get('pronouns').getError('maxlength').requiredLength }})
          </mat-error>
        </mat-form-field>
      </ng-container>
      <mat-form-field class="mat-form-field-width-100">
        <mat-label i18n="@@profileView.editDialog.headline.label"
          >Headline
        </mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          autocomplete="off"
          formControlName="short_bio"
          [maxlength]="shortBioCharLimit"
        >
        </textarea>
        <mat-hint align="end">
          {{ form.value.short_bio?.length || 0 }}/{{ shortBioCharLimit }}
        </mat-hint>
        <mat-error
          *ngIf="form.get('short_bio').hasError('maxlength')"
          i18n="@@profileView.editDialog.headline.error"
        >
          Sorry, the text you entered is too long! ({{
            form.get('short_bio').getError('maxlength').actualLength
          }}/{{ form.get('short_bio').getError('maxlength').requiredLength }})
        </mat-error>
      </mat-form-field>
      <p
        i18n="@@profileView.editDialog.basicInfo.subtitle"
        class="text-subtitle-1 u-marginBottom-16"
      >
        Basic information
      </p>
      <div fxLayout="row">
        <div fxFlex="32px" class="u-paddingTop-16">
          <mat-icon class="color-grey-300">work</mat-icon>
        </div>
        <div
          formGroupName="experience"
          fxFlex="calc(100% - 32px)"
          fxLayout.gt-sm="row"
          fxLayoutGap.gt-sm="1%"
        >
          <mat-form-field
            fxFlex.gt-sm="49%"
            class="mat-form-field-width-100 u-marginBottom-16"
          >
            <mat-label i18n="@@profileView.editDialog.jobTitle.label"
              >Job title
            </mat-label>
            <input
              matInput
              formControlName="job_title"
              autocomplete="off"
              [maxlength]="CHARACTER_LIMIT"
              #inputExperienceJobTitle
            />
            <mat-hint align="end">
              {{ form.value.experience.job_title.length }}/{{ CHARACTER_LIMIT }}
            </mat-hint>
            <mat-error
              *ngIf="
                form.get(['experience', 'job_title']).hasError('maxlength')
              "
              i18n="@@profileView.editDialog.jobTitle.error"
            >
              Sorry, the text you entered is too long! ({{
                form.get(['experience', 'job_title']).getError('maxlength')
                  .actualLength
              }}/{{
                form.get(['experience', 'job_title']).getError('maxlength')
                  .requiredLength
              }})
            </mat-error>
          </mat-form-field>
          <mat-form-field
            fxFlex.gt-sm="49%"
            class="mat-form-field-width-100 u-marginBottom-16"
          >
            <mat-label i18n="@@profileView.editDialog.organizationName.label"
              >Organization name
            </mat-label>
            <input
              matInput
              formControlName="organization_name"
              autocomplete="off"
              [maxlength]="CHARACTER_LIMIT"
            />
            <mat-hint align="end">
              {{ form.value.experience.organization_name.length }}/{{
                CHARACTER_LIMIT
              }}
            </mat-hint>
            <mat-error
              *ngIf="
                form
                  .get(['experience', 'organization_name'])
                  .hasError('maxlength')
              "
              i18n="@@profileView.editDialog.organizationName.error"
            >
              Sorry, the text you entered is too long! ({{
                form
                  .get(['experience', 'organization_name'])
                  .getError('maxlength').actualLength
              }}/{{
                form
                  .get(['experience', 'organization_name'])
                  .getError('maxlength').requiredLength
              }})
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex="32px" class="u-paddingTop-16">
          <mat-icon class="color-grey-300">public</mat-icon>
        </div>
        <mat-form-field
          class="mat-form-field-width-100 u-marginBottom-16"
          fxFlex="calc(100% - 32px)"
        >
          <mat-label i18n="@@profileView.editDialog.website.label"
            >Website (i.e. LinkedIn)
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="website"
            autocomplete="off"
            #inputWebsite
          />
          <mat-hint i18n="@@profileView.editDialog.website.hint">
            Enter any website where people can find more info about you (like
            your LinkedIn)
          </mat-hint>
          <mat-error
            *ngIf="form.get('website').hasError('invalidUrl')"
            i18n="@@profileView.editDialog.website.error"
          >
            Website is not a valid URL
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row">
        <div fxFlex="32px" class="u-paddingTop-16">
          <mat-icon class="color-grey-300">location_on</mat-icon>
        </div>
        <div formGroupName="geo_location" fxFlex="calc(100% - 32px)">
          <mat-form-field class="mat-form-field-width-100 u-marginBottom-16">
            <mat-label i18n="@@profileView.editDialog.location.label"
              >Location
            </mat-label>
            <input
              type="text"
              matInput
              formControlName="address"
              [matAutocomplete]="locationAutocomplete"
              #inputLocation
            />
            <mat-hint
              *ngIf="!form.value.geo_location.address"
              i18n="@@profileView.editDialog.location.hint"
            >
              Start typing and select a location from the suggestions.
            </mat-hint>
            <mat-error
              *ngIf="
                form
                  .get(['geo_location', 'address'])
                  ?.hasError('invalidLocation')
              "
              i18n="@@profileView.editDialog.location.error"
            >
              Please select a location from the suggestions.
            </mat-error>
            <mat-autocomplete #locationAutocomplete="matAutocomplete">
              <mat-option
                *ngFor="let option of filteredLocationOptions | async"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div
        *ngIf="!(tenantState | async)?.hidden_base_profile_fields?.education"
        fxLayout="row"
      >
        <div fxFlex="32px" class="u-paddingTop-16">
          <mat-icon class="color-grey-300">school</mat-icon>
        </div>
        <div formGroupName="education" fxFlex="calc(100% - 32px)">
          <div fxLayout.gt-sm="row" fxLayoutGap.gt-sm="1%">
            <mat-form-field
              fxFlex.gt-sm="49%"
              class="mat-form-field-width-100 u-marginBottom-8"
            >
              <mat-label i18n="@@profileView.editDialog.schoolProgram.label"
                >School Program
              </mat-label>
              <input
                matInput
                formControlName="program"
                autocomplete="off"
                [maxlength]="CHARACTER_LIMIT"
                #inputSchoolProgram
              />
              <mat-hint align="end">
                {{ form.value.education.program.length }}/{{ CHARACTER_LIMIT }}
              </mat-hint>
              <mat-error
                *ngIf="form.get(['education', 'program']).hasError('maxlength')"
                i18n="@@profileView.editDialog.schoolProgram.error"
              >
                Sorry, the text you entered is too long! ({{
                  form.get(['education', 'program']).getError('maxlength')
                    .actualLength
                }}/{{
                  form.get(['education', 'program']).getError('maxlength')
                    .requiredLength
                }})
              </mat-error>
            </mat-form-field>
            <mat-form-field
              fxFlex.gt-sm="49%"
              class="mat-form-field-width-100 u-marginBottom-8"
            >
              <mat-label i18n="@@profileView.editDialog.schoolGradYear.label"
                >Class of
              </mat-label>
              <input
                matInput
                formControlName="class_of"
                autocomplete="off"
                maxlength="4"
                i18n-placeholder="
                  @@profileView.editDialog.schoolGradYear.placeholder"
                placeholder="Class of (YYYY)"
              />
            </mat-form-field>
          </div>
          <mat-form-field class="mat-form-field-width-100 u-marginBottom-16">
            <mat-label i18n="@@profileView.editDialog.school.label"
              >School
            </mat-label>
            <input
              matInput
              formControlName="school"
              autocomplete="off"
              [maxlength]="CHARACTER_LIMIT"
            />
            <mat-hint align="end">
              {{ form.value.education.school.length }}/{{ CHARACTER_LIMIT }}
            </mat-hint>
            <mat-error
              *ngIf="form.get(['education', 'school']).hasError('maxlength')"
              i18n="@@profileView.editDialog.school.error"
            >
              Sorry, the text you entered is too long! ({{
                form.get(['education', 'school']).getError('maxlength')
                  .actualLength
              }}/{{
                form.get(['education', 'school']).getError('maxlength')
                  .requiredLength
              }})
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <ng-container *ngIf="isUser || user.isAdmin">
        <p
          i18n="@@profileView.editDialog.about.subtitle"
          class="text-subtitle-1 u-marginBottom-16"
        >
          About {{ profile.first_name }}
        </p>
        <mat-form-field class="mat-form-field-width-100">
          <mat-label i18n="@@profileView.editDialog.about.label"
            >About
          </mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            autocomplete="off"
            formControlName="about"
            [maxlength]="aboutCharacterLimit"
            #inputAbout
          >
          </textarea>
          <mat-hint align="end">
            {{ form.value.about?.length || 0 }}/{{ aboutCharacterLimit }}
          </mat-hint>
          <mat-error
            *ngIf="form.get('about').hasError('maxlength')"
            i18n="@@profileView.editDialog.about.error"
          >
            Sorry, the text you entered is too long! ({{
              form.get('about').getError('maxlength').actualLength
            }}/{{ form.get('about').getError('maxlength').requiredLength }})
          </mat-error>
        </mat-form-field>
      </ng-container>
    </form>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="u-width-100">
    <div>
      <ng-container *ngIf="error">
        <mat-error>
          <span
            i18n="@@profileView.editDialog.error"
            class="u-wordWrap-breakWord"
            >{error, select, other {{{ error }}}
          }</span>
        </mat-error>
      </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <button
        mat-button
        (click)="checkForUnsavedChanges()"
        i18n="@@global.cancel"
      >
        Cancel
      </button>
      <button
        mat-button
        color="primary"
        [disabled]="
          !form?.valid ||
          isLoading ||
          isLoadingImage ||
          showLinkedInAuth ||
          !formHasChanges
        "
        (click)="save()"
      >
        <span i18n="@@global.saveChanges">Save changes</span>
        <i
          *ngIf="isLoading || isLoadingImage"
          nz-icon
          nzType="sync"
          nzTheme="outline"
          nzSpin
          class="u-marginRight-8"
        ></i>
      </button>
    </div>
  </div>
</mat-dialog-actions>
